import { render, staticRenderFns } from "./PartnerCard.vue?vue&type=template&id=30807217&scoped=true"
import script from "./PartnerCard.vue?vue&type=script&lang=js"
export * from "./PartnerCard.vue?vue&type=script&lang=js"
import style0 from "./PartnerCard.vue?vue&type=style&index=0&id=30807217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30807217",
  null
  
)

export default component.exports